<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{isCreating?'Crea un departamento':'Edita un departamento'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label for="name" class="form-label">Nombre del departamento<span
							class="required">*</span></label>
						<input type="text" placeholder="Ingresa el nombre del departamento" name="name"
							id="name" [(ngModel)]="newDepartment.name" class="form-control">
					</div>
					<div class="form-group">
						<label for="area" class="form-label">Area del departamento<span
							class="required">*</span></label>
						<select name="area" id="area" class="form-select" [(ngModel)]="newDepartment.area">
							<option *ngFor="let area of areas" value="{{area.id}}">{{area.name}}</option>
						</select>
					</div>
					<div class="form-group">
						<label for="position" class="form-label">Jefe del departamento</label>
						<select name="position" id="position" [(ngModel)]="newDepartment.head" class="form-select">
							<option *ngFor="let position of positions" value="{{position.id}}">{{position.name}}</option>
						</select>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'crear el departamento':'guardar los cambios'}} </p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!newDepartment.name || !newDepartment.area || loading"
						(click)="createOrEdit()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>{{isCreating?'CREAR':'EDITAR'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>